import UiReducer from './UiReducer';
import HomeReducer from './HomeReducer';
import GeneralReducer from './GeneralReducer';
const rootReducer = {
	ui: UiReducer.reducer,
	home: HomeReducer.reducer,
	general: GeneralReducer.reducer,
};

export default rootReducer;
